export const _en = {
    id: {
        label: "Id"
    },
    name: {
        label: "Name"
    },
    isPublish: {
        label: "Publish"
    } 
};

export const _fr = {
    id: {
        label: "Id"
    },
    name: {
        label: "Nom"
    },
    isPublish: {
        label: "Publié pour mon service"
    }     
};